import { combineReducers } from "@reduxjs/toolkit";
import { airStaffApi } from "../../features/catalogues/lib/airStaff/airStaffApi";
import { airBaseApi } from "../../features/catalogues/lib/airBase/airBaseApi";
import { airTransportApi } from "../../features/catalogues/lib/airTransport/airTransportApi";
import { contractorsApi } from "../../features/catalogues/lib/contractors/contractorsApi";
import { contractApi } from "../../features/catalogues/lib/contracts/contractApi";
import { workTypesApi } from "../../features/catalogues/lib/workTypes/workTypesApi";
import { contracWorkstApi } from "../../features/catalogues/lib/contractWorks/contractWorksApi";
import { contractAircraftsApi } from "../../features/catalogues/lib/contractAircrafts/contractAircraftApi";
import { transportApi } from "../../api/transportApi";
import { flightApi } from "../../features/catalogues/lib/flight/flightApi";
import { workCostApi } from "../../features/catalogues/lib/workCost/workCostApi";
import { worksCompletedApi } from "../../features/catalogues/lib/worksCompleted/worksCompletedApi";
import { pilotsApi } from "../../features/catalogues/lib/pilots/pilotsApi";
import { reviewApi } from "../../features/catalogues/lib/review/reviewApi";
import { landCategoryApi } from "../../api/landCategoriesApi";
import { routesApi } from "../../api/routesApi";

const rootReducer = combineReducers({
  [airStaffApi.reducerPath]: airStaffApi.reducer,
  [airBaseApi.reducerPath]: airBaseApi.reducer,
  [airTransportApi.reducerPath]: airTransportApi.reducer,
  [contractorsApi.reducerPath]: contractorsApi.reducer,
  [contractApi.reducerPath]: contractApi.reducer,
  [flightApi.reducerPath]: flightApi.reducer,
  [workTypesApi.reducerPath]: workTypesApi.reducer,
  [contracWorkstApi.reducerPath]: contracWorkstApi.reducer,
  [contractAircraftsApi.reducerPath]: contractAircraftsApi.reducer,
  [transportApi.reducerPath]: transportApi.reducer,
  [workCostApi.reducerPath]: workCostApi.reducer,
  [worksCompletedApi.reducerPath]: worksCompletedApi.reducer,
  [pilotsApi.reducerPath]: pilotsApi.reducer,
  [reviewApi.reducerPath]: reviewApi.reducer,
  [landCategoryApi.reducerPath]: landCategoryApi.reducer,
  [routesApi.reducerPath]: routesApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
